export enum UserHistoryOptions {
  UPCOMING = 'UPCOMING',
  ACCOMPLISHED = 'ACCOMPLISHED'
}

